import { useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { DisplayCode } from "../../components/DisplayCode";
import MainContainer from "../../components/MainContainer";
import { TicketInfo } from "../../components/TicketInfo";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import NotFound from "../NotFound";

const PrintTicketPage = () => {
	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});
	const location = useLocation();
	const payload = location?.state?.payload;

	useDocumentTitle("Εκτύπωση εισιτηρίου");

	if (!payload) {
		return <NotFound />;
	}

	return (
		<MainContainer>
			<div className="col-lg-7">
				<Link to="/ticket-office/ticket-info?user=over-67" className="btn btn-back mb-4">
					<svg className="govgr-svg-icon--caret govgr-svg-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
						<path d="M18,22V2L6,12L18,22z"></path>
					</svg>
					Πίσω
				</Link>
				<h1 className="mb-4">Ημεδαπός φίλαθλος χωρίς smartphone</h1>
				<TicketInfo {...payload} />
			</div>

			<DisplayCode displayMode={payload?.displayMode ?? "QR"} value={payload?.privateCode ?? "-"} handlePrint={handlePrint} />

			<div style={{ display: "none" }}>
				<div className="d-flex flex-row flex-fill p-4" ref={componentRef}>
					<div className="row">
						<div className="col-6">
							<TicketInfo {...payload} />
						</div>
						<div className="col-6 mt-2">
							<DisplayCode
								displayMode={payload?.displayMode ?? "QR"}
								value={payload?.privateCode ?? "-"}
								handlePrint={handlePrint}
								ignorePrint
							/>
						</div>
					</div>
				</div>
			</div>
		</MainContainer>
	);
};

export default PrintTicketPage;
